export const CONNECT = 'CONNECT';
export const SENDDATA = 'SENDDATA';
export const HANDLEDATA = 'HANDLEDATA';
export const DISCONNECT = 'DISCONNECT';

export default {
  CONNECT,
  SENDDATA,
  HANDLEDATA,
  DISCONNECT,
};



// WEBPACK FOOTER //
// ./src/store/modules/socket/mutation-types.js